import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _class, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import Grid from './internal/GridElement';
import { defaultGridColumns } from './internal/vars';
export default withTheme((_temp = _class = /*#__PURE__*/function (_Component) {
  _inherits(AkGrid, _Component);

  var _super = _createSuper(AkGrid);

  function AkGrid() {
    var _this;

    _classCallCheck(this, AkGrid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getTheme", function (props) {
      return {
        columns: props.theme && props.theme.columns ? props.theme.columns : defaultGridColumns,
        spacing: props.theme && props.theme.spacing ? props.theme.spacing : props.spacing,
        isNestedGrid: props.theme && props.theme.isNestedGrid ? props.theme.isNestedGrid : false
      };
    });

    return _this;
  }

  _createClass(AkGrid, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          layout = _this$props.layout,
          spacing = _this$props.spacing,
          testId = _this$props.testId;
      return /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: this.getTheme(this.props)
      }, /*#__PURE__*/React.createElement(Grid, {
        "data-testid": testId,
        spacing: spacing,
        layout: layout
      }, this.props.children));
    }
  }]);

  return AkGrid;
}(Component), _defineProperty(_class, "defaultProps", {
  spacing: 'cosy',
  layout: 'fixed'
}), _temp));